import { Controller } from '../utils/controller';
import { useClickOutside } from 'stimulus-use';

export default class extends Controller {
  static targets = ['button', 'caret', 'dropdown'];

  // TARGETS
  declare parentTarget: HTMLElement;
  declare buttonTarget: HTMLElement;
  declare caretTarget: HTMLElement;
  declare dropdownTarget: HTMLElement;

  connect() {
    useClickOutside(this);
  }

  clickOutside(event) {
    event.preventDefault();

    this.dropdownTarget.classList.add('hidden');
    this.caretTarget.classList.remove('rotate-180');
  }

  toggleDropdown() {
    this.dropdownTarget.classList.toggle('hidden');
    this.caretTarget.classList.toggle('rotate-180');

    const isExpanded = this.buttonTarget.getAttribute('aria-expanded');
    this.buttonTarget.setAttribute('aria-expanded', this.toggleAriaExpanded(isExpanded));
  }

  toggleAriaExpanded(val) {
    return val === 'true' ? 'false' : 'true';
  }
}
